import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import {
  DefaultDevice,
  OauthAEMConfig,
  SelectDevicePayload,
  SubmitSmsNumber
} from '../../../models';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class SetDefaultDeviceService {
  defaultMethodHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.setDefaultDevice+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  setDefaultDevice = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    deviceId: string
  ): Observable<SubmitSmsNumber> => {
    const defaultDevice = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const defaultDeviceUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: defaultDevice
      }
    ];

    const payload: SelectDevicePayload = {
      deviceRef: {
        id: deviceId
      }
    };

    return new ApiBuilder<SelectDevicePayload, DefaultDevice>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(defaultDeviceUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.defaultMethodHeader)
      .errorHandler(this._errorHandler)
      .library('SET_DEFAULT_DEVICE_SERVICE')
      .withCredentials(true)
      .create();
  };
}
